import React from "react";
import SearchMap from "./SearchMap";
import Navbar from "./Navbar";

export default function App() {
    return (
        <div className="App">
            <Navbar />
            <SearchMap />
        </div>
    );
}